'use strict';

import React from 'react';
import Analytics from '../utils/Analytics';
import AnalyticsEvents from '../constants/AnalyticsEvents';
import ZineActionCreators from '../actions/ZineActionCreators';
import ZineSectionsStore from '../stores/ZineSectionsStore';
import createStoreMixin from '../mixins/createStoreMixin';
import DocumentTitle from '../atoms/DocumentTitle';
import PureRenderMixin from '../mixins/PureRenderMixin';
import PageQueryMixin from '../mixins/PageQueryMixin';
import ZineSection from '../organisms/ZineSection';
import AppContext from '../AppContext';
import Page from '../organisms/Page';
import NavigationContextTypes from '../constants/NavigationContextTypes';
import OffsetMonitor from '../atoms/OffsetMonitor';
import findLast from 'lodash/collection/findLast';
import ScrollStateMixin from '../mixins/ScrollStateMixin';

var ListedZinesPage = React.createClass({
  mixins: [
    ScrollStateMixin,
    createStoreMixin(ZineSectionsStore),
    PageQueryMixin,
    PureRenderMixin
  ],

  getStateFromStores() {
    return {
      sections: ZineSectionsStore.getSections()
    };
  },

  componentWillMount() {
    this._offsets = {};
  },

  componentDidMount() {
    ZineActionCreators.requestZineSections(true);
    Analytics.trackEvent(AnalyticsEvents.ZINES_VIEW);
  },

  getNavigationContext() {
    const { isScrolled, scrolledSectionId } = this.state;
    return [NavigationContextTypes.ZINES, { isScrolled, scrolledSectionId }];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    return {
      navigationContextType,
      navigationContextOptions
    };
  },

  getScrollState(scrollY) {
    const { sections } = this.state || {};

    const lastScrolledSection = findLast(
      sections,
      section => this.hasScrolledPastOffset(this._offsets[section.id])
    );

    return {
      isScrolled: scrollY > 52,
      scrolledSectionId: lastScrolledSection && lastScrolledSection.id
    };
  },

  render() {
    const { sections } = this.state;
    return (
      <DocumentTitle title='Collections'>
        <AppContext {...this.getAppContext()}>
          <Page showFooter>
            {sections.map(this.renderZineSection)}
          </Page>
        </AppContext>
      </DocumentTitle>
    );
  },

  renderZineSection(section, index) {
    return (
      <OffsetMonitor onOffsetTopChange={this.handleOffsetTopChange.bind(this, section.id)}
                     key={`zineSection-${section.id}`}>
        <ZineSection section={section}
                     onParsePage={this.handleParsePage.bind(this, index)}
                     onPageChange={this.handlePageChange.bind(this, index)} />
      </OffsetMonitor>
    );
  },

  handleParsePage(index) {
    return this.parsePage(index);
  },

  handlePageChange(index, page) {
    return this.replacePage(index, page);
  },

  handleOffsetTopChange(sectionId, offsetTop) {
    this._offsets[sectionId] = offsetTop;
    this.updateScrollState();
  }
});

export default ListedZinesPage;



/** WEBPACK FOOTER **
 ** ./pages/ListedZinesPage.jsx
 **/